import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import { PageRoute } from './constants'
import { DashBoard } from '../pages/DashBoard/DashBoardScreen'
import DocumentScreen from '../pages/Document/DocumentScreen'
import SignIn from '../pages/SignIn'
import NavBar from '../components/organisms/NavBar/NavBar'
import { LoggedInWrapper, SectionWrapper, NavBarWrapper, NavBarWrapperSmallScreen } from './styled'
import { useSelector } from 'react-redux'
import { MainState } from '../redux/reducers'
import { useCallback, useEffect, useRef, useState } from 'react'
import { getAuth, signOut, User } from 'firebase/auth'
import app from '../firebase/initialize'
import Header from '../components/organisms/Header/Header'
import { CreateDocument } from '../pages/CreateDocument/CreateDocument'
import Account from '../pages/Account'
import Whitelist from '../pages/Whitelist'
import SignUp from '../pages/SignUp'
import SignInWithVerification from '../pages/SignInWithVerification'

import { store } from '../redux'
import { RESET } from '../redux/misc/types'
import ResetPassword from '../pages/ResetPassword'
import SetNewPassword from '../pages/SetNewPassword'
import Verification from '../pages/Verification'
import moment from 'moment'
import { ViewDocument } from '../pages/ViewDocument /ViewDocument'
import EggSingleDocument from '../components/organisms/EggSingleDocument'
import CreateEggDocument from '../components/organisms/CreateEggDocument'
import UpdateDocument from '../pages/UpdateDocument/UpdateDocument'

function Main() {
  let uid = useSelector((state: MainState) => state.misc.uid)
  const auth = getAuth(app)
  const [user, setUser] = useState<User | null>()
  const [loading, setLoading] = useState(true)
  const open = useSelector((state: MainState) => state.misc.openHamburger)

  const emailVerified = useRef(true)

  auth.onAuthStateChanged(function (_user) {
    setUser(_user)
    setLoading(false)
  })
  useEffect(() => {
    if (user) {
      const creationDate = moment(user.metadata.creationTime)

      if (!user.emailVerified && creationDate > moment('2022-04-01)', 'YYYY-MM-DD')) {
        signOut(getAuth(app))

        store.dispatch({
          type: RESET,
        })
        emailVerified.current = false
      }
    }
    if (!user) {
      emailVerified.current = true
    }
  })

  // För att skydda routes

  const requiresAuth = useCallback(
    (renderer: any) => {
      return uid ? renderer : <Redirect to={PageRoute.ACCOUNT} />
    },
    [uid],
  )

  return (
    <Router>
      <Switch>
        <Route path={PageRoute.SIGNUP} exact>
          <SignUp />
        </Route>
        <Route path={PageRoute.SIGNIN} exact>
          <SignIn emailVerified={emailVerified.current} />
        </Route>
        <Route path={PageRoute.SIGNIN_VERIFICATION} exact>
          <SignInWithVerification />
        </Route>
        <Route path={PageRoute.RESET_PASSWORD} exact>
          <ResetPassword />
        </Route>
        <Route path={PageRoute.SET_NEW_PASSWORD} exact>
          <SetNewPassword />
        </Route>
        <Route path={PageRoute.VERIFICATION} exact>
          <Verification />
        </Route>

        {!user && !loading && <Redirect to={PageRoute.SIGNIN} />}
        {user && (
          <>
            <Switch>
              <Route
                path={`${PageRoute.DOCUMENTS}/:docId/eggs`}
                exact
                render={() =>
                  requiresAuth(
                    <>
                      {<Header />}
                      <LoggedInWrapper>
                        <NavBarWrapper>
                          <NavBar />
                        </NavBarWrapper>
                        {open && (
                          <NavBarWrapperSmallScreen>
                            <NavBar />
                          </NavBarWrapperSmallScreen>
                        )}
                        <SectionWrapper>
                          <EggSingleDocument />
                        </SectionWrapper>
                      </LoggedInWrapper>
                      ,
                    </>,
                  )
                }
              ></Route>
              <Route
                path={`${PageRoute.DOCUMENTS}/:docId/:product`}
                exact
                render={() =>
                  requiresAuth(
                    <>
                      {<Header />}
                      <LoggedInWrapper>
                        <NavBarWrapper>
                          <NavBar />
                        </NavBarWrapper>
                        {open && (
                          <NavBarWrapperSmallScreen>
                            <NavBar />
                          </NavBarWrapperSmallScreen>
                        )}
                        <SectionWrapper>
                          <ViewDocument />
                        </SectionWrapper>
                      </LoggedInWrapper>
                      ,
                    </>,
                  )
                }
              ></Route>
            </Switch>
            <Route
              path={PageRoute.DOCUMENTS}
              exact
              render={() =>
                requiresAuth(
                  <>
                    <Header screenName="Indata" />
                    <LoggedInWrapper>
                      <NavBarWrapper>
                        <NavBar />
                      </NavBarWrapper>
                      {open && (
                        <NavBarWrapperSmallScreen>
                          <NavBar />
                        </NavBarWrapperSmallScreen>
                      )}
                      <SectionWrapper>
                        <DocumentScreen uid={uid!} />
                      </SectionWrapper>
                    </LoggedInWrapper>
                  </>,
                )
              }
            />
            <Route
              path={PageRoute.START}
              exact
              render={() =>
                requiresAuth(
                  <>
                    <Header screenName="Insikter" />
                    <LoggedInWrapper>
                      <NavBarWrapper>
                        <NavBar />
                      </NavBarWrapper>
                      {open && (
                        <NavBarWrapperSmallScreen>
                          <NavBar />
                        </NavBarWrapperSmallScreen>
                      )}
                      <SectionWrapper>
                        <DashBoard uid={uid!} />
                      </SectionWrapper>
                    </LoggedInWrapper>
                  </>,
                )
              }
            />
            <Switch>
              <Route
                path={`${PageRoute.CREATE_DOCUMENT}/eggs`}
                exact
                render={() =>
                  requiresAuth(
                    <>
                      <Header screenName="Skapa ny avräkning" />
                      <LoggedInWrapper>
                        <NavBarWrapper>
                          <NavBar />
                        </NavBarWrapper>
                        {open && (
                          <NavBarWrapperSmallScreen>
                            <NavBar />
                          </NavBarWrapperSmallScreen>
                        )}
                        <SectionWrapper>
                          <CreateEggDocument />
                        </SectionWrapper>
                      </LoggedInWrapper>
                    </>,
                  )
                }
              />
              <Route
                path={`${PageRoute.CREATE_DOCUMENT}/:product`}
                exact
                render={() =>
                  requiresAuth(
                    <>
                      <Header screenName="Skapa ny avräkning" />
                      <LoggedInWrapper>
                        <NavBarWrapper>
                          <NavBar />
                        </NavBarWrapper>
                        {open && (
                          <NavBarWrapperSmallScreen>
                            <NavBar />
                          </NavBarWrapperSmallScreen>
                        )}
                        <SectionWrapper>
                          <CreateDocument />
                        </SectionWrapper>
                      </LoggedInWrapper>
                    </>,
                  )
                }
              />
            </Switch>
            <Route
              path={PageRoute.ACCOUNT}
              exact
              render={() =>
                requiresAuth(
                  <>
                    <Header screenName="Konto" />
                    <LoggedInWrapper>
                      <NavBarWrapper>
                        <NavBar />
                      </NavBarWrapper>
                      {open && (
                        <NavBarWrapperSmallScreen>
                          <NavBar />
                        </NavBarWrapperSmallScreen>
                      )}
                      <SectionWrapper>
                        <Account uid={uid!} />
                      </SectionWrapper>
                    </LoggedInWrapper>
                  </>,
                )
              }
            />
            <Route
              path={PageRoute.WHITELIST}
              exact
              render={() =>
                requiresAuth(
                  <>
                    <Header screenName="Konto > Vitlistade addresser" />
                    <LoggedInWrapper>
                      <NavBarWrapper>
                        <NavBar />
                      </NavBarWrapper>
                      {open && (
                        <NavBarWrapperSmallScreen>
                          <NavBar />
                        </NavBarWrapperSmallScreen>
                      )}
                      <SectionWrapper>
                        <Whitelist />
                      </SectionWrapper>
                    </LoggedInWrapper>
                  </>,
                )
              }
            />
            <Route
              path={`${PageRoute.UPDATE_DOCUMENT}/:docId`}
              exact
              render={() =>
                requiresAuth(
                  <>
                    <Header screenName="Ändra i dokumentet" />
                    <LoggedInWrapper>
                      <NavBarWrapper>
                        <NavBar />
                      </NavBarWrapper>
                      {open && (
                        <NavBarWrapperSmallScreen>
                          <NavBar />
                        </NavBarWrapperSmallScreen>
                      )}
                      <SectionWrapper>
                        <UpdateDocument />
                      </SectionWrapper>
                    </LoggedInWrapper>
                  </>,
                )
              }
            />
          </>
        )}
      </Switch>
    </Router>
    /*  <>
      {uid ? (
        <LoggedInWrapper>
          <NavBar />
          <SectionWrapper>
            <DashBoard uid={uid} />
          </SectionWrapper>
        </LoggedInWrapper>
      ) : (
        <SignIn />
      )}
    </> */
  )
  // }
}
export default Main
